import { colors } from "@/theme";
import { Checkbox, styled, TextField } from "@mui/material";
import checkIcon from "@/assets/check-icon.svg";

export const CustomCheckbox = styled(Checkbox)({
    padding: 8,
    "& .MuiSvgIcon-root": {
      display: "none",
    },
    "& .MuiCheckbox-root": {
      padding: 0,
    },
    "&::before": {
      content: '""',
      display: "block",
      width: 32,
      height: 32,
      border: `1px solid ${colors.neutralGrey300}`,
      borderRadius: 4,
      boxSizing: "border-box",
    },
    "&.Mui-checked::after": {
      content: '""',
      position: "absolute",
      left: "50%",
      top: "50%",
      transform: "translate(-50%, -50%)",
      width: 10,
      height: 7,
      background: `url(${checkIcon}) center/contain no-repeat`,
    },
  });
  
 export const CustomTextField = styled(TextField)({
    "& .MuiOutlinedInput-root": {
      borderRadius: 4,
      fontFamily: "PF DIN Text Pro",
      "& fieldset": {
        borderColor: colors.neutralGrey400,
      },
      "&:hover fieldset": {
        borderColor: colors.neutralGrey400,
      },
      "&.Mui-focused fieldset": {
        borderColor: colors.neutralGrey400,
      },
    },
    "& .MuiInputLabel-root": {
      fontFamily: "PF DIN Text Pro",
    },
    "& .MuiFormHelperText-root": {
      fontFamily: "PF DIN Text Pro",
    },
  });